import { render } from "./ProjectMaterials.vue?vue&type=template&id=09f59884&scoped=true"
import script from "./ProjectMaterials.vue?vue&type=script&lang=js"
export * from "./ProjectMaterials.vue?vue&type=script&lang=js"

import "./ProjectMaterials.vue?vue&type=style&index=0&id=09f59884&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f59884"]])

export default __exports__